import React, { createElement as _createElement } from 'react';
import classnames from 'classnames';
import S from './RowHeaderView.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class RowHeaderView extends React.Component {
  constructor(props) {
    super(props);
    this.ref = /*#__PURE__*/React.createRef();
    this.state = {
      height: 0,
      style: {
        height: 0
      }
    };
  }

  /**
   * Invoked when the container holding the row headers is scrolled. This
   * will tell the linearView to scroll.
   * @param {Object} evt 
   * @returns 
   */
  onScroll = evt => {
    if (this.lock === true) {
      return;
    }
    const {
      linearViewRef
    } = this.props;
    const top = evt.target.scrollTop;
    if (linearViewRef && linearViewRef.current) {
      this.lock = true;
      window.requestAnimationFrame(() => {
        linearViewRef.current.setScroll(top);
        this.lock = false;
      });
    }
  };

  /**
   * This is invoked by the LinearView to indicate that a scroll in the content
   * area has occurred
   * @param {Object} evt 
   */
  onContentScroll = evt => {
    const {
      height
    } = this.state;
    if (evt.headerHeight !== height) {
      this.setState({
        height: evt.headerHeight,
        style: {
          height: `${evt.headerHeight}px`
        }
      });
    }
    if (!this.lock && this.ref.current && this.ref.current.scrollTop !== evt.top) {
      this.ref.current.scrollTop = evt.top;
    }
  };
  render() {
    const {
      data,
      rowAccess,
      // data 
      renderer: Renderer,
      rendererProps,
      // for renderer mode
      children,
      headerChildren
    } = this.props;
    const {
      style
    } = this.state;
    let comp = children;
    if (Renderer) {
      const rows = rowAccess == null ? data : rowAccess(data);
      if (Array.isArray(rows)) {
        comp = rows.map((item, idx) => {
          // eslint-disable-next-line react/no-array-index-key
          return /*#__PURE__*/_createElement(Renderer, {
            ...rendererProps,
            item: item,
            index: idx,
            key: idx
          });
        });
      }
    }
    return /*#__PURE__*/_jsxs("div", {
      className: S.rowIndex,
      children: [/*#__PURE__*/_jsx("div", {
        className: S.rowSpacer,
        style: style,
        children: headerChildren
      }), /*#__PURE__*/_jsx("div", {
        ref: this.ref,
        onScroll: this.onScroll,
        className: classnames(S.rowContent, Renderer && S.scroll),
        children: comp
      })]
    });
  }
}
export default RowHeaderView;